import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import StyledIcon from '../Icon/styled.js';

var Text = styled(Box).withConfig({
  displayName: "styled__Text",
  componentId: "sc-9qokh7-0"
})(["abbr&{border-bottom:1px dotted;cursor:help;text-decoration:none;}i&{font-style:italic;}kbd&{background:#454d5d;border-radius:0.1rem;color:#fff;fill:#fff;padding:0.1rem 0.2rem;}mark&{background:#ffe9b3;border-radius:0.1rem;padding:0.1rem 0.2rem;}strong&{font-weight:bold;}sub&,sup&{font-size:0.8em;vertical-align:baseline;}ins&,u&{text-decoration-skip:ink edges;}i&,cite&,var&,em&{font-style:italic;}kbd&,pre&,samp&{font-family:'SF Mono','Segoe UI Mono','Roboto Mono',Menlo,Courier,monospace;}& ", "{top:0.15em;}", ";"], selector(StyledIcon), theme('fannypack.Text.base'));

export default Text;
export { Text };
